import React, { Fragment } from "react";
import { Card, Col, Button } from 'react-bootstrap';
import '../../../../../../styles/diario.scss';

const Fiscal = (props) => {


    const deletar = async (id) => {
        props.deletar(id)
        await props.fetchFiscais()
    }

    const editar = async (id) => {
        props.editar(id)
    }
    return (
        <Fragment>
            <Col>
                <Card className='card-list'>
                    <Card.Body>
                        <Card.Title className="cabeca-card" key={props.key}>{props.fiscal.servidor} Matrícula: {props.fiscal.matricula}</Card.Title>
                        <p>Secretaria: {props.fiscal.secretaria}</p>
                        <p>Posição: {props.fiscal.posicao}</p>
                        <p>Objeto: {props.fiscal.objeto}</p>
                        <p>{props.fiscal.referencia} de {props.fiscal.ano}</p> 
                    </Card.Body>
                    <hr />
                    <Button type="button" className="botao-leis" onClick={() => editar(props.fiscal._id)} variant='primary'>Editar</Button>
                    <Button type='button' className="botao-leis" onClick={() => deletar(props.fiscal._id)} variant='danger'>Excluir</Button>
                </Card>
            </Col>
        </Fragment >)
}

export default Fiscal;